import type Quill from 'quill/core';
import type { Parchment } from 'quill/core';
import React from 'react';
import { useApolloClient } from '@apollo/client';
import { MenuItem } from '../../components/Menu';
import mentionIcon from '../../icons/non-prefilled/16x16/mention.svg';
import replaceEmbedBlotWith from '../utils/replaceEmbedBlotWith';
import fetchPostAnchorTitle from '../utils/fetchPostAnchorTitle';
import Attachment from '../formats/Attachment';

type ConvertIntoMentionMenuItemProps = {
  quill: Quill;
} & (
  | {
      blot: Parchment.EmbedBlot;
      type: string;
      id: string;
    }
  | {
      blot: Attachment;
      type?: never;
      id?: never;
    }
);

const ConvertIntoMentionMenuItem = ({
  quill,
  ...props
}: ConvertIntoMentionMenuItemProps) => {
  const apollo = useApolloClient();

  return (
    <MenuItem
      icon={mentionIcon}
      onClick={async () => {
        if (props.blot instanceof Attachment) {
          replaceEmbedBlotWith(
            quill,
            props.blot,
            {
              'attachment-mention': props.blot.getAttachmentFiles(),
            },
            props.blot.formats(),
          );
          return;
        }

        const { blot, type, id } = props;
        let attributes;
        if (type === 'post') {
          const title = await fetchPostAnchorTitle(apollo, id);
          if (title) {
            attributes = { 'mention-text': title };
          }
        }
        replaceEmbedBlotWith(
          quill,
          blot,
          { mention: { type, id } },
          attributes,
        );
      }}
      testId="convertIntoMentionMenuItem"
    >
      Convert into mention
    </MenuItem>
  );
};

export default ConvertIntoMentionMenuItem;
